import Modal from './Modal';
import './HelpModal.css';

function HelpModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="How To Play">
      <div className="help-content">
        <p>Guess the <strong>6-letter word</strong> in 7 tries.</p>

        <p>Each guess must be a valid 6-letter word. Hit the enter button to submit.</p>

        <p>After each guess, the color of the tiles will change to show how close your guess was to the word.</p>

        <div className="examples">
          <p><strong>Examples:</strong></p>

          <div className="example">
            <div className="example-tiles">
              <div className="example-tile correct">P</div>
              <div className="example-tile">Y</div>
              <div className="example-tile">T</div>
              <div className="example-tile">H</div>
              <div className="example-tile">O</div>
              <div className="example-tile">N</div>
            </div>
            <p className="example-desc">
              The letter <strong>P</strong> is in the word and in the correct spot.
            </p>
          </div>

          <div className="example">
            <div className="example-tiles">
              <div className="example-tile">C</div>
              <div className="example-tile present">O</div>
              <div className="example-tile">D</div>
              <div className="example-tile">I</div>
              <div className="example-tile">N</div>
              <div className="example-tile">G</div>
            </div>
            <p className="example-desc">
              The letter <strong>O</strong> is in the word but in the wrong spot.
            </p>
          </div>

          <div className="example">
            <div className="example-tiles">
              <div className="example-tile">V</div>
              <div className="example-tile">I</div>
              <div className="example-tile">S</div>
              <div className="example-tile absent">U</div>
              <div className="example-tile">A</div>
              <div className="example-tile">L</div>
            </div>
            <p className="example-desc">
              The letter <strong>U</strong> is not in the word in any spot.
            </p>
          </div>
        </div>

        <hr />

        <p className="note">
          <strong>A new puzzle is released daily at midnight!</strong>
        </p>
      </div>
    </Modal>
  );
}

export default HelpModal;